import { useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';

// Campo de senha com o "olho" para mostrar/ocultar o que está sendo digitado (padrão do ecossistema EIMOVEL:
// todo campo de senha deve ter). Aceita as mesmas props de <Form.Control> (value, onChange, required,
// minLength, autoFocus, autoComplete...) — `type` é controlado aqui. Dentro de <Form.Group controlId=...> o id
// é herdado normalmente, então o <Form.Label> continua apontando para o campo.
export default function CampoSenha(props) {
  const [visivel, setVisivel] = useState(false);
  return (
    <InputGroup>
      <Form.Control {...props} type={visivel ? 'text' : 'password'} />
      <Button
        type="button"
        variant="outline-secondary"
        tabIndex={-1}
        onClick={() => setVisivel((v) => !v)}
        aria-label={visivel ? 'Ocultar senha' : 'Mostrar senha'}
        title={visivel ? 'Ocultar senha' : 'Mostrar senha'}
      >
        <i className={`bi ${visivel ? 'bi-eye-slash' : 'bi-eye'}`} />
      </Button>
    </InputGroup>
  );
}
